export default {
  loadingMessage: null,
  notification: null
};
